import { render, staticRenderFns } from "./assignMenu.vue?vue&type=template&id=e8fa5bd0"
import script from "./assignMenu.vue?vue&type=script&lang=js"
export * from "./assignMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports